import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import * as Icons from "lucide-react";

export default function ServiceCard({ service, index }) {
  const Icon = Icons[service.icon] || Icons.Scale;
  return (
    <Link
      to={`/services/${service.slug}`}
      data-testid={`service-card-${service.slug}`}
      className="group relative flex flex-col justify-between bg-paper p-8 md:p-10 transition-all duration-500 hover:bg-bone min-h-[280px] overflow-hidden"
    >
      <span className="absolute top-6 right-6 text-[10px] tracking-[0.3em] text-ink/30 font-sans">
        {String(index + 1).padStart(2, "0")}
      </span>

      <div className="flex flex-col gap-5">
        <Icon className="w-7 h-7 text-brand" strokeWidth={1.25} />
        <h3 className="font-display text-xl md:text-2xl leading-tight text-ink group-hover:text-brand transition-colors duration-300">
          {service.title.split("—")[0].trim()}
        </h3>
      </div>

      <div className="mt-8 flex items-end justify-between">
        <p className="font-serif text-base text-ink/65 leading-snug max-w-[18rem]">
          {service.short}
        </p>
        <ArrowUpRight
          className="w-5 h-5 text-ink/40 group-hover:text-brand group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-300 shrink-0 ml-3"
          strokeWidth={1.25}
        />
      </div>
    </Link>
  );
}
